import { get, merge, filter, indexOf } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS, HTTP_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc Typeahead defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { TypeaheadService } from 'services/typeahead';
 *
 * // create service instance and send/cancel request
 * const typeaheadService = new TypeaheadService();
 * const result = await typeaheadService.fetchData( '<user-id>' ); // fetch data
 * typeaheadService.cancel(); // cancel an active request
 */
export class TypeaheadService extends HttpService {

    // fetch options from the service
    async fetchOptions( { url = {}, data = {}, ignoreOptions = [] } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        callerType,
                    }
                } ),
            } );

            // handle failure
            if( SERVICE_RESPONSE_STATUS.FAILURE === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {
                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: {
                        description: get( response, 'body.component.data.description', {} ),
                    }
                };
            }

            const options = get( response, 'body.component.data.options', [] );

            const updatedList = filter( options, dataOption => {
                return -1 === indexOf( ignoreOptions, dataOption.value );
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: updatedList
            };

        } catch( error ) {
            
            if( HTTP_RESPONSE_STATUS.NONE === get( error, 'data.status', 0 ) ) {
                return {
                    status: SERVICE_RESPONSE_STATUS.CANCELLED,
                    data: null,
                };
            } else {
                return {
                    status: SERVICE_RESPONSE_STATUS.FAILURE,
                    data: null,
                };
            }
        }
    }
}
